export const RecommendedAction = {
  LIKE: 'like',
  HIDE: 'hide',
  BLOCK: 'block',
  DELETE: 'delete',
  PUBLIC_REPLY: 'public_reply',
  REVIEW: 'review',
};
